import _, { get as _get, forOwn as _forOwn } from 'lodash-es';

import {
  sorting,
  shopifyObj,
  collectionFilterSpxApiUrl,
  CollectiongraphLabel,
  graphLabel,
} from '../utils/Constants';
import CompatibleWithHelper from './CompatibleWithHelper';
import copy from 'copy-to-clipboard';
export const getFilterAttributesFromAPI = async ProductDataFromCommerce => {
  const requestHeaders = new Headers();
  requestHeaders.append('Content-Type', 'application/json');
  const raw = JSON.stringify({
    merchant_key: shopifyObj.merchantKey,
    product_list: ProductDataFromCommerce.productList,
    // graph_label: graphLabel !== undefined ? graphLabel : 'qa',
    graph_label:
      CollectiongraphLabel !== undefined ? CollectiongraphLabel : 'qa',
    switch: 'fast',
  });
  // console.log(CollectiongraphLabel,'CollectiongraphLabel')
  const requestOptions = {
    method: 'POST',
    headers: requestHeaders,
    body: raw,
    redirect: 'follow',
  };
  const IsPlatformShopify =
    typeof _get(window, 'compatioConfig.shopify') === 'object';
  const authorization = `JWT ${window.compatioConfig.compatioApiKey}`;
  let merchantKey = '';
  let fullApiEndpoint = '';
  let targetGraph = '';
  let collectionFillterUrlSpx = '';
  let collectionGraph = '';
  if (IsPlatformShopify) {
    targetGraph = _get(window, 'compatioConfig.shopify.targetGraph');
    if (targetGraph == 'Live') {
      collectionFillterUrlSpx = collectionFilterSpxApiUrl[0].Url;
      collectionGraph = collectionFilterSpxApiUrl[0].label;
    } else if (targetGraph == 'LiveV2') {
      collectionFillterUrlSpx = collectionFilterSpxApiUrl[0].Url;
      collectionGraph = collectionFilterSpxApiUrl[0].label;
    } else if (targetGraph == 'LiveV2-api') {
      collectionFillterUrlSpx = collectionFilterSpxApiUrl[2].Url;
      collectionGraph = collectionFilterSpxApiUrl[2].label;
    } else {
      collectionFillterUrlSpx = collectionFilterSpxApiUrl[1].Url;
      collectionGraph = collectionFilterSpxApiUrl[1].label;
    }

    // console.log(
    //   collectionFilterSpxApiUrl,
    //   'collectionFilterSpxApiUrl',
    //   CollectiongraphLabel
    // );
  }
  try {
    const result = await fetch(collectionFillterUrlSpx, requestOptions);
    if (result && result.status === 200) {
      return result.json();
    } else {
      console.log('error');
      return [];
    }
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getFilterAttributesFromAPITry = async ProductDataFromCommerce => {
  const requestHeaders = new Headers();
  // console.log(ProductDataFromCommerce,'ProductDataFromCommerce')
  requestHeaders.append('Content-Type', 'application/json');
  const raw = JSON.stringify({
    merchant_key: shopifyObj.merchantKey,
    product_list: ProductDataFromCommerce,
    // graph_label: graphLabel !== undefined ? graphLabel : 'qa',
    graph_label:
      CollectiongraphLabel !== undefined ? CollectiongraphLabel : 'qa',
    switch: 'fast',
  });
  // console.log(CollectiongraphLabel,'CollectiongraphLabel')
  const requestOptions = {
    method: 'POST',
    headers: requestHeaders,
    body: raw,
    redirect: 'follow',
  };
  const IsPlatformShopify =
    typeof _get(window, 'compatioConfig.shopify') === 'object';
  const authorization = `JWT ${window.compatioConfig.compatioApiKey}`;
  let merchantKey = '';
  let fullApiEndpoint = '';
  let targetGraph = '';
  let collectionFillterUrlSpx = '';
  let collectionGraph = '';
  if (IsPlatformShopify) {
    targetGraph = _get(window, 'compatioConfig.shopify.targetGraph');
    if (targetGraph == 'Live') {
      collectionFillterUrlSpx = collectionFilterSpxApiUrl[0].Url;
      collectionGraph = collectionFilterSpxApiUrl[0].label;
    } else if (targetGraph == 'LiveV2') {
      collectionFillterUrlSpx = collectionFilterSpxApiUrl[0].Url;
      collectionGraph = collectionFilterSpxApiUrl[0].label;
    } else if (targetGraph == 'LiveV2-api') {
      collectionFillterUrlSpx = collectionFilterSpxApiUrl[2].Url;
      collectionGraph = collectionFilterSpxApiUrl[2].label;
    } else {
      collectionFillterUrlSpx = collectionFilterSpxApiUrl[1].Url;
      collectionGraph = collectionFilterSpxApiUrl[1].label;
    }

    // console.log(
    //   collectionFilterSpxApiUrl,
    //   'collectionFilterSpxApiUrl',
    //   CollectiongraphLabel
    // );
  }
  try {
    const result = await fetch(collectionFillterUrlSpx, requestOptions);
    if (result && result.status === 200) {
      return result.json();
    } else {
      console.log('error');
      return [];
    }
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const sortProductList = (sortOrder, productList) => {
  // Create copy to ensure data immutability
  const products = productList.slice();
  const sortedProducts = products.sort((productA, productB) => {
    const productKey = sorting[sortOrder].productKey;
    const sortDirection = sorting[sortOrder].sortDirection;
    let result = 1;
    // console.log(productKey,productA,productB)
    if (productKey === 'productName') {
      result =
        productA[productKey].toUpperCase() > productB[productKey].toUpperCase()
          ? 1
          : -1;
    } else if (productKey === 'price') {
      result = productA[productKey] > productB[productKey] ? 1 : -1;
    } else if (productKey === 'createdAt') {
      result =
        new Date(productA[productKey]).getTime() >
        new Date(productB[productKey]).getTime()
          ? 1
          : -1;
    } else if (productKey === 'compatioScore') {
      // result = productA[productKey] > productB[productKey] ? 1 : -1;

      result = productA[productKey] > productB[productKey] ? -1 : 1;

      // console.log(productA[productKey] , productB[productKey])
    }

    if (sortDirection === 'descending') {
      result *= -1;
    }
    return result;
  });

  return sortedProducts;
};

export const sortProductListApplyFilter = (sortOrder, productList) => {
  // Create copy to ensure data immutability
  // console.log(sortOrder,productList[0].categoryData)

  let beforeSort = productList.map(e => e.variants);
  let afterSortData = [];
  beforeSort.forEach(e => {
    e.forEach(ee => {
      afterSortData.push(ee);
    });
  });

  var clean = afterSortData.filter(
    (arr, index, self) =>
      index ===
      self.findIndex(t => t.merchantProductSku === arr.merchantProductSku)
  );

  const newsortedProducts = sortProductList(sortOrder, clean);
  // getCollapsedProductData(newsortedProducts, currentCategory, appliedFilters);

  const CollapsedProducts = [];
  // previously working code for collapsing - this created issue for daves - so commented
  let group = _.groupBy(newsortedProducts, 'parentProductId');
  _forOwn(group, (collapsedVariants, key) => {
    // console.log(collapsedVariants[0].groupset,'group')
    CollapsedProducts.push({
      product: key,
      variants: collapsedVariants,
      groupset: collapsedVariants[0].groupset,
      categoryName: collapsedVariants[0].categoryName,
    });
  });

  return CollapsedProducts;
};

export const sortFilterValues = filterArray => {
  filterArray.forEach(filter => {
    if (filter != undefined) {
      if (filter.attr == 'tippet-weight-lbs') {
        filter.values.sort((a, b) => {
          let result = +a.value > +b.value ? 1 : +a.value - +b.value ? -1 : 1;
          return result;
        });
      } else if (filter.attr == 'rod-length') {
        filter.values.sort((a, b) => {
          let result =
            +a.value.replace(/"/g, '').replace(/'/g, '.') >
            +b.value.replace(/"/g, '').replace(/'/g, '.')
              ? 1
              : +a.value.replace(/"/g, '').replace(/'/g, '.') -
                +b.value.replace(/"/g, '').replace(/'/g, '.')
              ? -1
              : 1;
          let results =
            a.value
              .replace(/'/g, '.')
              .replace(/.10/g, '.99')
              .slice(0, -1) -
            b.value
              .replace(/'/g, '.')
              .replace(/.10/g, '.99')
              .slice(0, -1);
          // console.log(
          //   a.value
          //     .replace(/'/g, '.')
          //     .replace(/.10/g, '.99')
          //     .slice(0, -1),
          //   b.value
          //     .replace(/'/g, '.')
          //     .replace(/.10/g, '.99')
          //     .slice(0, -1)
          // );
          return results;
        });
      } else if (filter.attr == 'priceFilter') {
        filter.values = filter.values.sort((valueA, valueB) => {
          if (valueA['value'] >= 0 && valueB['value'] >= 0) {
            let aa = valueA['value'];
            let bb = valueB['value'];
            let result = Number(aa) > Number(bb) ? 1 : -1;
            return result;
          }
        });
      } else {
        filter.values.sort((valueA, valueB) => {
          if (
            valueA['value'].indexOf("'") >= 0 &&
            valueB['value'].indexOf("'") >= 0
          ) {
            let result =
              parseInt(valueA['value'].split("'")[0]) >
              parseInt(valueB['value'].split("'")[0])
                ? 1
                : -1;
            return result;
          } else {
            let result = isNaN(valueA['value'])
              ? valueA['value'].toLowerCase() > valueB['value'].toLowerCase()
                ? 1
                : -1
              : +valueA['value'] > +valueB['value']
              ? 1
              : -1;
            return result;
          }
        });
      }
    }
  });
  return filterArray;
};

export const sortFilterValuesBuilder = filterArray => {
  filterArray.forEach(filter => {
    if (filter != undefined) {
      if (filter.attr == 'tippet-weight-lbs') {
        filter.values.sort((a, b) => {
          let result = +a.value > +b.value ? 1 : +a.value - +b.value ? -1 : 1;
          return result;
        });
      } else if (filter.attr == 'rod-length') {
        filter.values.sort((a, b) => {
          let result =
            +a.value.replace(/"/g, '').replace(/'/g, '.') >
            +b.value.replace(/"/g, '').replace(/'/g, '.')
              ? 1
              : +a.value.replace(/"/g, '').replace(/'/g, '.') -
                +b.value.replace(/"/g, '').replace(/'/g, '.')
              ? -1
              : 1;
          let results =
            a.value
              .replace(/'/g, '.')
              .replace(/.10/g, '.99')
              .slice(0, -1) -
            b.value
              .replace(/'/g, '.')
              .replace(/.10/g, '.99')
              .slice(0, -1);
          // console.log(
          //   a.value
          //     .replace(/'/g, '.')
          //     .replace(/.10/g, '.99')
          //     .slice(0, -1),
          //   b.value
          //     .replace(/'/g, '.')
          //     .replace(/.10/g, '.99')
          //     .slice(0, -1)
          // );
          return results;
        });
      } else {
        filter.values.sort((valueA, valueB) => {
          if (
            valueA['value'].indexOf("'") >= 0 &&
            valueB['value'].indexOf("'") >= 0
          ) {
            let result =
              parseInt(valueA['value'].split("'")[0]) >
              parseInt(valueB['value'].split("'")[0])
                ? 1
                : -1;
            return result;
          } else {
            let result = isNaN(valueA['value'])
              ? valueA['value'].toLowerCase() > valueB['value'].toLowerCase()
                ? 1
                : -1
              : +valueA['value'] > +valueB['value']
              ? 1
              : -1;
            return result;
          }
        });
      }
    }
  });
  return filterArray.filter(e => e != undefined);
};

// sorting set for spcial for collection filters... Page Name : CollectionFilterSection.js
export const sortFilterValuesCollection = filterArray => {
  filterArray.forEach(filter => {
    if (filter.attr == 'rod-length') {
      filter.values = filter.values.sort((valueA, valueB) => {
        if (
          valueA['value'].indexOf("'") >= 0 &&
          valueB['value'].indexOf("'") >= 0
        ) {
          let aa = valueA['value']
            .replace("'10", '.99')
            .replace("'", '.')
            .split('"')
            .join('');
          let bb = valueB['value']
            .replace("'10", '.99')
            .replace("'", '.')
            .split('"')
            .join('');
          let result = Number(aa) > Number(bb) ? 1 : -1;
          return result;
        } else {
          let result = isNaN(valueA['value'])
            ? valueA['value'].toLowerCase() > valueB['value'].toLowerCase()
              ? 1
              : -1
            : parseInt(valueA['value']) > parseInt(valueB['value'])
            ? 1
            : -1;

          return result;
        }
      });
    } else if (filter.attr == 'priceFilter') {
      filter.values = filter.values.sort((valueA, valueB) => {
        if (valueA['value'] >= 0 && valueB['value'] >= 0) {
          let aa = valueA['value'];
          let bb = valueB['value'];
          let result = Number(aa) > Number(bb) ? 1 : -1;
          return result;
        }
      });
    } else {
      // console.log(filter.attr)
      filter.values = filter.values.sort((valueA, valueB) => {
        if (
          valueA['value'].indexOf("'") >= 0 &&
          valueB['value'].indexOf("'") >= 0
        ) {
          let result =
            parseInt(valueA['value'].split("'")[0]) >
            parseInt(valueB['value'].split("'")[0])
              ? 1
              : -1;

          return result;
        } else {
          let result = isNaN(valueA['value'])
            ? valueA['value'].toLowerCase() > valueB['value'].toLowerCase()
              ? 1
              : -1
            : parseInt(valueA['value']) > parseInt(valueB['value'])
            ? 1
            : -1;

          return result;
        }
      });
    }
  });
  return filterArray;
};

export const getCurrentFiltersForCollection = () => {
  let currentFilters = localStorage.getItem(shopifyObj.collectionHandle);
  if (currentFilters === null || currentFilters === undefined) {
    currentFilters = [];
  } else {
    currentFilters = JSON.parse(currentFilters);
  }
  return currentFilters;
};

export const getCurrentFiltersForBuilder = currentFilterData => {
  let Filters = [];
  for (var index in currentFilterData) {
    const filterMeta = index.split('🗲');
    if (filterMeta) {
      let filterValues = currentFilterData[index].values;
      let filterValueList = [];
      for (var attr in filterValues) {
        let filterattrs = attr.split('🗲');
        let filterDisplayName = filterattrs[1];
        if (filterDisplayName === 'None') {
          filterDisplayName = filterattrs[0].toLowerCase();
        }
        if (filterDisplayName === '') {
          filterDisplayName = filterattrs[0];
        }

        filterValueList.push({
          value: filterDisplayName,
          metaValue: attr,
          attribute: index,
          count: filterValues[attr],
          checked: false,
        });
      }
      filterValueList = filterValueList.sort((valueA, valueB) => {
        if (
          valueA['value'].indexOf("'") >= 0 &&
          valueB['value'].indexOf("'") >= 0
        ) {
          let result =
            parseInt(valueA['value'].split("'")[0]) >
            parseInt(valueB['value'].split("'")[0])
              ? 1
              : -1;
          return result;
        } else {
          let result = isNaN(valueA['value'])
            ? valueA['value'].toLowerCase() > valueB['value'].toLowerCase()
              ? 1
              : -1
            : parseInt(valueA['value']) > parseInt(valueB['value'])
            ? 1
            : -1;

          return result;
        }
      });
      Filters.push({
        attr: filterMeta[0],
        name: filterMeta[1] === 'undefined' ? filterMeta[0] : filterMeta[1],
        values: filterValueList,
        valuesPerRow: filterMeta[3],
      });
    }
  }
  return Filters;
};
